export default __webpack_public_path__ + "static/media/winstonc.49a78bf6.gif";